import { ComparePageObjectModel } from '@/poms/comparePageObjectModel';
import { Box, styled } from '@mui/material';
import { CollapsibleLines } from './CollapsibleLines';
import { renderLineText } from './renderLineText';
import { TextDiffLine, TextDiffRow } from './textDiffRows';
import { DiffText, LineNumber } from './textDiffStyles';

const SplitGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'min-content minmax(0, 1fr) min-content minmax(0, 1fr)',
});

const isUnchangedRow = (row: TextDiffRow) => row.left?.kind === 'unchanged';

const getRowKey = (row: TextDiffRow) => `${row.left?.lineNumber ?? '-'}:${row.right?.lineNumber ?? '-'}`;

const DiffSide = ({ line, side }: { line?: TextDiffLine; side: 'left' | 'right' }) => {
  const kind = line?.kind ?? 'empty';
  return (
    <>
      <LineNumber data-kind={kind} data-side={side}>
        {line?.lineNumber}
      </LineNumber>
      <DiffText data-kind={kind}>{line && renderLineText(line)}</DiffText>
    </>
  );
};

const renderRow = (row: TextDiffRow) => (
  <>
    <DiffSide line={row.left} side='left' />
    <DiffSide line={row.right} side='right' />
  </>
);

export const SplitDiffView = ({ rows }: { rows: TextDiffRow[] }) => (
  <SplitGrid data-testid={ComparePageObjectModel.TextDiffSplitView}>
    <CollapsibleLines lines={rows} isUnchanged={isUnchangedRow} getKey={getRowKey} renderLine={renderRow} />
  </SplitGrid>
);
